module.exports = __webpack_public_path__ + "img/Frame 132.4b599335.png";